export default {
  CLIENT_USER: 'CLIENT_USER',
  HEADHUNTER: 'HEADHUNTER',
  ADMIN: 'ADMIN',
};
